// extracted by mini-css-extract-plugin
export var downArrow = "_9v-0";
export var infoTooltipIcon = "_9v-3";
export var label = "_9v-1";
export var optionCard = "_9v-4";
export var upArrow = "_9v-2";